export default function FlexibilidadeSection() {
  const flexibilidades = [
    {
      icon: 'ri-door-open-line',
      title: 'Entre a qualquer momento',
      description: 'Não precisa esperar a próxima turma. Comece sua jornada quando estiver pronta e acesse as gravações dos módulos anteriores.'
    },
    {
      icon: 'ri-video-line',
      title: 'Acesso às gravações',
      description: 'Todas as aulas ficam gravadas e disponíveis para você assistir quantas vezes quiser, no seu ritmo e horário.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Reposição de encontros',
      description: 'Perdeu um encontro ao vivo? Sem problemas! Assista a gravação ou faça reposição em turmas futuras.'
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'Módulos avulsos',
      description: 'Prefere focar em temas específicos? Você pode comprar módulos individuais de acordo com suas necessidades.'
    }
  ];

  return (
    <section className="py-24 bg-purple-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="font-display text-5xl font-bold text-purple-900 mb-16">
          Flexibilidade total para sua rotina
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {flexibilidades.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 flex items-start space-x-6 hover:border-l-8 hover:border-gold-500 transition-all duration-300 shadow-sm hover:shadow-lg cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center flex-shrink-0 bg-purple-100 rounded-full">
                <i className={`${item.icon} text-purple-600 text-3xl`}></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-purple-900 mb-3">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
